var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3327 16.2526V19.2526C21.3338 19.5311 21.2768 19.8068 21.1652 20.062C21.0536 20.3171 20.89 20.5462 20.6848 20.7345C20.4796 20.9228 20.2373 21.0661 19.9734 21.1553C19.7096 21.2445 19.4301 21.2777 19.1527 21.2526C16.0755 20.9183 13.1197 19.8668 10.5227 18.1826C8.10652 16.6473 6.05803 14.5988 4.5227 12.1826C2.83267 9.57382 1.78094 6.60361 1.4527 3.51262C1.42771 3.23608 1.46057 2.95738 1.5492 2.69424C1.63782 2.43111 1.78027 2.18931 1.96746 1.98424C2.15466 1.77917 2.3825 1.61533 2.63649 1.50314C2.89047 1.39095 3.16504 1.33288 3.4427 1.33262H6.4427C6.928 1.32784 7.39849 1.4997 7.76646 1.81615C8.13443 2.1326 8.37477 2.57206 8.4427 3.05262C8.56932 4.01268 8.80415 4.95534 9.1427 5.86262C9.27724 6.22054 9.30636 6.60953 9.2266 6.9835C9.14685 7.35746 8.96156 7.70073 8.6927 7.97262L7.4227 9.24262C8.84625 11.7462 10.9192 13.8191 13.4227 15.2426L14.6927 13.9726C14.9646 13.7038 15.3079 13.5185 15.6818 13.4387C16.0558 13.359 16.4448 13.3881 16.8027 13.5226C17.71 13.8612 18.6526 14.096 19.6127 14.2226C20.0985 14.2911 20.5421 14.5358 20.8592 14.9101C21.1764 15.2844 21.3449 15.7622 21.3327 16.2526Z",
    stroke: "#666666",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.c9733668228a57768b0d545029fe3095.svg";
export { ForwardRef as ReactComponent };